import { jsxs, jsx } from 'react/jsx-runtime';
import { styled, Grid } from '@mui/material';
import brandclub_colors from '../../../colors/brandclubColors.js';
import { formatMoney } from '../../../utils/stringUtils.js';

const Container = styled('div')({
    width: 340,
    marginLeft: 'auto',
    marginRight: 'auto',
    '.row': {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '7.5px 0',
        ':nth-last-of-type(2)': {
            paddingBottom: 20,
        },
    },
    '.total-row': {
        fontWeight: 600,
        borderTop: `1px solid ${brandclub_colors.blueWhiteBorder}`,
        padding: '20px 0 15px',
    },
});
const RewardTable = ({ rows, containerStyle = {} }) => {
    const totalRewards = rows.reduce((acc, [, amount]) => acc + amount, 0);
    return (jsxs(Container, Object.assign({ style: containerStyle }, { children: [rows.map((row, index) => (jsxs(Grid, Object.assign({ container: true, className: "row" }, { children: [jsx(Grid, Object.assign({ item: true }, { children: row[0] })), jsx(Grid, Object.assign({ item: true }, { children: formatMoney(row[1]) }))] }), index))), jsxs(Grid, Object.assign({ container: true, className: "row total-row" }, { children: [jsx(Grid, Object.assign({ item: true }, { children: "Total rewards" })), jsx(Grid, Object.assign({ item: true }, { children: formatMoney(totalRewards) }))] }))] })));
};

export { RewardTable };
//# sourceMappingURL=RewardTable.js.map
